enum SocketEnum {
  /**
   * 这枚举包含全部的 socket 返回类型
   */

    // 实时买卖价格，时间
  EXCHANGE_DEPTH = 'EXCHANGE_DEPTH',
  //订单三个卡片
  ORDER_PROFIT = 'ORDER_PROFIT',
  //资金浮动
  GET_FUNDS = 'GET_FUNDS',
  //返回的市场信息 ，数组格式
  EXCHANGE_RATE = 'EXCHANGE_RATE',

  //合约订单
  CONTRACT_ORDER = 'CONTRACT_ORDER',
  //

  //资金
  ACCOUNT_INFO = 'ACCOUNT_INFO',
  //股票订单
  STOCK_ORDER = 'STOCK_ORDER',

  // 资金
  FAIT_INFO = 'FAIT_INFO',
  // 合约
  CONTRACT_INFO = 'CONTRACT_INFO',

  /**
   * 充值审核通知
   */
  RECHARGE_SYSTEM_NOTICE = 'RECHARGE_SYSTEM_NOTICE',

  /**
   * 提现审核通知
   */
  WITHDRAWAL_SYSTEM_NOTICE = 'WITHDRAWAL_SYSTEM_NOTICE',

  /**
   * 钱包金额变更通知
   */
  WALLET_UPDATE_SYSTEM_NOTICE = 'WALLET_UPDATE_SYSTEM_NOTICE',
  /**
   * 未读消息通知
   */
  UNREAD_MESSAGE_SYSTEM_NOTICE = 'UNREAD_MSG_COUNT',

  VERSION = 'VERSION_UPDATE',

  /**
   * 全仓合约订单强平
   */
  CONTRACT_FORCED_LIQUIDATION = 'CONTRACT_FORCED_LIQUIDATION',
  /**
   * vip审核通知
   */
  VIP_AUDIT = 'VIP_AUDIT',
  /**
   * 股票止盈完成
   */
  STOCK_STOP_PROFIT = 'STOCK_STOP_PROFIT',

  /**
   * 股票止损完成
   */
  STOCK_STOP_LOSS = 'STOCK_STOP_LOSS',

  /**
   * 后端推送资金相关数据
   */
  NEW_ACCOUNT_STATISTICS = 'NEW_ACCOUNT_STATISTICS',

  /**
   * 逐仓合约订单强平
   */
  ISOLATED_CONTRACT_FORCED_LIQUIDATION = 'ISOLATED_CONTRACT_FORCED_LIQUIDATION',
  /**
   * 限价合约订单完成
   */
  CONTRACT_LIMIT = 'CONTRACT_LIMIT',
  /**
   * 合约订单止盈止损完成
   */
  CONTRACT_STOP_PROFIT_LOSS = 'CONTRACT_STOP_PROFIT_LOSS',
  /**
   * 合约订单止盈止盈完成
   */
  CONTRACT_STOP_PROFIT = 'CONTRACT_STOP_PROFIT',
  /**
   * 合约订单止损完成
   */
  CONTRACT_STOP_LOSS = 'CONTRACT_STOP_LOSS',
  /**
   * 合约带单跟单完成
   */
  CONTRACT_LEAD_TRADING = 'CONTRACT_LEAD_TRADING',
  /**
   * 合约带单平仓完成
   */
  CONTRACT_LEAD_TRADING_COMPLETE = 'CONTRACT_LEAD_TRADING_COMPLETE',

  /**
   * 后台消息
   */
  ADMIN_ACTIVE = 'ADMIN_ACTIVE',

  // 更新k线 ，返回订阅列表
  EXCHANGE_CANDLESTICK = 'EXCHANGE_CANDLESTICK',

  // 强制退出 注销登录
  FORCE_LOGOUT = 'FORCE_LOGOUT',
  //更新钱包
  WALLET_UPDATE = 'WALLET_UPDATE',
  // 实名失败
  USER_REAL_NAME = 'USER_REAL_NAME',
  // 资金费率
  FUNDING_RATE = 'FUNDING_RATE',
  // 跟单完成 [止盈、止损、平仓 、撤销],
  STOCK_ORDER_REFRESH = 'STOCK_ORDER_REFRESH',
  // 刷新用户信息
  MEMBER_INFO_UPDATE = 'MEMBER_INFO_UPDATE',
  // 刷新贷款信息
  LOAN_INFO_UPDATE = 'LOAN_INFO_UPDATE',
}

export default SocketEnum;
